import { render, staticRenderFns } from "./redInvoice.vue?vue&type=template&id=5efcd0d9&scoped=true&"
import script from "./redInvoice.vue?vue&type=script&lang=js&"
export * from "./redInvoice.vue?vue&type=script&lang=js&"
import style0 from "./redInvoice.vue?vue&type=style&index=0&id=5efcd0d9&lang=less&scoped=true&"
import style1 from "./redInvoice.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5efcd0d9",
  null
  
)

export default component.exports